import clsx from 'clsx'
import { categories, Category } from '@/ui/pages/integrations/integrations.page'
import { useTranslation } from 'react-i18next'

interface IntegrationTabsProps {
  onCategoryChange: (category: string) => void
  activeCategory: Category
}

export const IntegrationTabs = ({
  onCategoryChange,
  activeCategory
}: IntegrationTabsProps) => {
  const { t } = useTranslation()
  const handleTabClick = (category: Category) => {
    onCategoryChange(category)
  }

  return (
    <div className="flex w-full items-center justify-between">
      <div className="flex items-center gap-2 rounded-md bg-neutral-200/70 p-1">
        {categories.map((category) => {
          return (
            <TabItem
              key={category}
              label={t(
                'integrations_store.categories.' +
                  category.toLocaleLowerCase().replace(' ', '_')
              )}
              active={activeCategory === category}
              onClick={() => handleTabClick(category)}
            />
          )
        })}
      </div>
    </div>
  )
}

interface TabItemProps {
  label: string
  active?: boolean
  onClick?: () => void
}

export const TabItem = ({ label, active, onClick }: TabItemProps) => {
  return (
    <div
      className={clsx(
        'flex cursor-pointer items-center rounded-md px-3 py-1 text-sm font-medium leading-tight',
        {
          'bg-white shadow-md text-[#0d111b]': active,
          'text-[#99a0ad]': !active
        }
      )}
      onClick={onClick}
    >
      <span>{label}</span>
    </div>
  )
}
